export const aboutObj = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  imgStart: false,
  img: require("../../images/851shots_so.png"),
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};

export const cliclaimObj = {
  id: "cliclaim",
};

export const discoverObj = {
  id: "discover",
  lightBg: true,
  lightText: true,
  lightTextDesc: true,
  imgStart: false,
  img: require("../../images/639shots_so.png"),
  dark: true,
  primary: true,
  darkText: false,
};

export const signupObj = {
  id: "signup",
  lightBg: true,
  lightText: true,
  lightTextDesc: true,
  imgStart: true,
  img: require("../../images/15shots_so9.png"),
  alt: "svg3",
  dark: true,
  primary: true,
  darkText: false,
};
